import { makeAutoObservable, runInAction } from 'mobx'
import { decorate, inject, injectable } from '@evertel/di'
import { LocalAsyncStorage } from '@evertel/utils'
import AsyncStorage from '@react-native-async-storage/async-storage'

const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

class DeviceTokenService {
    token: string | null = null

    constructor(
        private localStorage: LocalAsyncStorage
    ) {
        makeAutoObservable(this)
    }

    // Async init is required to load the value from local storage
    async init() {
        // On legacy LocalAsyncStorage using react-native-async-storage on Android, but RNFS for ios
        // The legacy code is storing deviceToken using react-native-async-storage always
        //
        // exception to load the old value and persist to the new store

        // get our deviceToken from local storage
        let token = await this.localStorage.getItem('deviceToken')

        if (token === null) {
            // check AsyncStorage just in case for iOS (old token key value for fallback)
            token = await AsyncStorage.getItem('@DeviceToken')
        }

        if (token === null) {
            // create a new token
            await this.resetToken()
        } else {
            runInAction(() => {
                this.token = token
            })
        }
    }

    // used to set a specific token, and save it to localStorage
    async setToken(token: string) {
        this.token = token
        return this.localStorage.setItem('deviceToken', this.token)
    }

    // sets token to null
    async clearToken() {
        this.token = null
        return this.localStorage.removeItem('deviceToken')
    }

    // Creates a new token and saves it
    async resetToken() {
        return this.setToken(generateUUID())
    }
}


decorate(injectable(), DeviceTokenService)
decorate(inject(LocalAsyncStorage), DeviceTokenService, 0)

export { DeviceTokenService }
